export default __webpack_public_path__ + "static/media/pc06-5-1.07ee9ba0.png";